<!--
패킹 컴포넌트 > 하우스정보
------------------------------------
-->
<template>
    <div class="root">
        <table class="house-info">
            <!--
            <tr>
                <th>
                    <i class="material-icons">
                        home
                    </i>
                    회원사
                </th>
                <td>
                    {{ house.user_nick }}
                </td>
            </tr>
            -->
            <tr>
                <th>
                    <i class="material-icons">
                        mail
                    </i>
                    회원 사서함
                </th>
                <td>
                    {{ house.user_mailbox }}
                </td>
            </tr>
            <tr>
                <th>
                    <i class="material-icons">
                        account_box
                    </i>
                    받는사람
                </th>
                <td>
                    {{ house.name }}
                </td>
            </tr>
            <tr>
                <th>
                    <i class="material-icons">
                        info
                    </i>
                    배송번호
                </th>
                <td>
                    {{ house.code }}
                </td>
            </tr>


        </table>
    </div>

</template>

<script>
export default {
    components: {},
    props: {
        // 하우스정보
        house: Object,
    },
    data: function () {
        return {};
    },
    computed: {},
    methods: {},
}
</script>

<style lang="scss" scoped>
.root {
    background-color: #fff;
    width: 100%;
}

.house-info {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;

    th, td {
        text-align: left;
        font-weight: normal;
        padding: 5px;
        border: 1px solid #cfcfcf;

    }

    th {
        width: 7rem;
        font-size: 1rem;
        color: #666;

        .material-icons {
            display: none; // 아이콘 표시안함
            vertical-align: middle;
            font-size: 1.5rem;
            color: #aaa;
        }

    }

    td {
        font-size: 1rem;
        color: #000;
    }

}
</style>